import LoginPage from './loginPage'

$('.js__loginPage').each((_, el) => {
  $(el).reactify(LoginPage)
})
